import { Box, Typography } from '@mui/material'

import { PopularQuestionsItem } from './popular-questions-item'

interface IProps {
  onQuestionClick: (text: string) => void
}

export const PopularQuestionsList = ({ onQuestionClick }: IProps) => {
  return (
    <Box sx={{ textAlign: 'center', marginBottom: '32px', marginTop: '32px', maxWidth: '840px' }}>
      <Typography sx={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px' }}>
        Popular questions:
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px' }}>
        <PopularQuestionsItem text="Top 5 sustainable coffee companies" onClick={onQuestionClick} />
        <PopularQuestionsItem text="What does ESG mean?" onClick={onQuestionClick} />
        <PopularQuestionsItem
          text="Recommend eco-friendly household products"
          onClick={onQuestionClick}
        />
      </Box>
    </Box>
  )
}
